import { utils, LitElement, html, broadcastReceiver } from './-global.min.js'

const { addToCart, reRenderShopifySections } = utils

class HHProductForm extends LitElement {
  constructor() {
    super()

    this.isBundle = this.classList.contains('js-bundle-form') === true
    this.form = this.querySelector('form')
    this.variantInput = this.querySelector('[name="id"]')
    this.quanityInput = this.querySelector('[name="quantity"]')
    this.sellingPlan = this.querySelector('[name="selling_plan"]')
    this.submitButton = this.querySelector('[type="submit"]')
    this.product_id = this.dataset.id
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this))
    this.changeATCStatus = this.changeATCStatus.bind(this)
    this._stickyATC = this._stickyATC.bind(this)
    this.variantMetafields = this._loadVariantMetafields()
    this._updateVariantTag = this._updateVariantTag.bind(this)
    this._updateVariantRestockNotice = this._updateVariantRestockNotice.bind(this)
    this.tagContainer = document.querySelector('.variant-tag-container')
  }

  connectedCallback() {
    super.connectedCallback()

    this.receiver = broadcastReceiver('quantity', (...args) => {
      this.getQuantityFromDocument(...args)
    })

    this._attachListeners()
  }

  disconnectedCallback() {
    super.disconnectedCallback()

    this.receiver.disconnect()
  }

  getQuantityFromDocument(data) {
    if (this.quanityInput) {
      this.quanityInput.value = data.value || 1
    }
  }

  async onSubmitHandler(event) {
    event.preventDefault()

    this.submitButton?.setAttribute('disabled', true)
    this.submitButton?.classList.add('loading')

    const items = []
    if (this.isBundle) {
      this.closest('.js-product-panel').querySelectorAll('.bundle-item-wrapper').forEach(item => {
        items.push({
          id: Number(item.dataset.variantId),
      //    selling_plan: item.dataset.sellingplan ? Number(item.dataset.sellingplan) : null,
          quantity: (item.dataset.variantId == '20481231487074' || item.dataset.variantId == '39670940794978' || item.dataset.variantId == '20481231749218' || item.dataset.variantId == '20481231913058' || item.dataset.variantId == '30764227461218' || item.dataset.variantId == '30764230770786' || item.dataset.variantId == '30764229951586' || item.dataset.variantId == '41330282725474' || item.dataset.variantId == '41330282758242') ? 2 : 1
        })
      })
    } else {
      items.push({
        id: parseInt(this.variantInput.value),
      //  selling_plan: parseInt(this.sellingPlan.value),
        quantity: parseInt(this.quanityInput.value)
      })

      const upsell_form = this.closest('.js-product-panel').querySelector('.js-upsell-item-hero') !== null ?
        this.closest('.js-product-panel')?.querySelector('.js-upsell-item-hero')?.querySelector('form[action="/cart/add"]') :
        false

      if (upsell_form) {
        items.push({
          id: parseInt(upsell_form.querySelector('[name="id"]').value),
          quantity: parseInt(upsell_form.querySelector('[name="quantity"]').value)
       //   selling_plan: parseInt(this.sellingPlan.value)
        })
      }
    }

    const formData = {
      items: items
    }

    reRenderShopifySections(await addToCart(formData))

    utils.toggle(document.body, ['mini-cart-is-active'])
    if (utils.isTablet()) {
      document.body.style.overflow = 'hidden'
    }

    this.submitButton?.removeAttribute('disabled')
    this.submitButton?.classList.remove('loading')
  }

  render() {
    return html`<slot></slot>`
  }

  changeATCStatus(available, productId = null) {
    let submitButton = this.querySelector('[type="submit"]');
    if(productId) {
      submitButton = this.querySelector(`button.bundle-item__action[data-product-id="${productId}"]`);
    }

    if (available) {
      submitButton?.removeAttribute('disabled')
      if (submitButton) {
        const labelEl = submitButton.querySelector('.atc-label') || submitButton
        labelEl.innerHTML = atc_labels.add_to_cart
      }
    } else {
      submitButton?.setAttribute('disabled', true)
      if (submitButton) {
        const labelEl = submitButton.querySelector('.atc-label') || submitButton
        // Redesign PDP (.atc-flex): keep the "Add to Cart" label — the sold-out
        // state is shown in the price (.atc-price) instead. Other templates keep
        // the original behaviour of swapping the label to "Sold Out".
        if (submitButton.classList.contains('atc-flex')) {
          labelEl.innerHTML = atc_labels.add_to_cart
        } else {
          labelEl.innerHTML = atc_labels.sold_out
        }
      }
    }
  }

  _loadVariantMetafields(productId = null) {
    let scriptTag = document.getElementById('VariantMetafields');
    if(productId) {
      scriptTag = document.querySelector(`#VariantMetafields[data-product-id="${productId}"]`);
    }
    if (!scriptTag) return [];
    try {
      return JSON.parse(scriptTag.textContent);
    } catch (err) {
      console.error('Failed to parse variant metafields JSON', err);
      return [];
    }
  }

  _attachListeners() {
    document.addEventListener('variant-available::change', (event) => {
      console.log(`_attachListeners event: ${JSON.stringify(event.detail)}`);
      /* if (!event.detail.is_bundle && this.product_id === event.detail.product_id) {
        this.changeATCStatus(event.detail.available);
        this._updateVariantTag(event.detail.variant_id);
      } */

      /* if(this.product_id === event.detail.product_id) {
        if(event.detail.is_bundle) {
          this.changeATCStatus(event.detail.available, event.detail.product_id);
          this._updateVariantTag(event.detail.variant_id, event.detail.product_id);
        }
        else {
          this.changeATCStatus(event.detail.available);
          this._updateVariantTag(event.detail.variant_id);
        }
      } */

      if(event.detail.is_bundle) {
        this.changeATCStatus(true, event.detail.available, event.detail.product_id);
        this._updateVariantTag(true, event.detail.variant_id, event.detail.product_id);
        this._updateVariantRestockNotice(true, event.detail.variant_id, event.detail.product_id);
      }
      else {
        if (this.product_id === event.detail.product_id) {
          this.changeATCStatus(event.detail.available);
          this._updateVariantTag(false, event.detail.variant_id);
          this._updateVariantRestockNotice(false, event.detail.variant_id);
        }
      }

    })

    document.addEventListener('scroll', (e) => this._stickyATC())
  }

  _updateVariantTag(is_bundle = false, variantId, productId = null) {
    let variantMetafields = this.variantMetafields;
    if(is_bundle) {
      //VariantMetafields[data-product-id="${productId}"]
      variantMetafields = this._loadVariantMetafields(productId);
    }
    const tagData = variantMetafields.find(item => item.variant_id === variantId);
    console.log(`variantId: ${variantId}`);
    console.log(`variantMetafields: ${JSON.stringify(this.variantMetafields)}`);
    console.log(`tagData: ${JSON.stringify(tagData)}`);

    let tagContainer = this.tagContainer;
    if(productId) {
      tagContainer = document.querySelector(`.variant-tag-container[data-product-id="${productId}"]`);
    }
    if (!tagContainer) return;
    
    if (tagData) {
      tagContainer.innerHTML = `
        ${tagData.icon ? `<span class="aic" data-variant-icon="${tagData.icon}"></span>` : ''}
        <span data-variant-tag>${tagData.label}</span>
      `;
      tagContainer.style.display = 'flex';
      if(tagData.label_color) {
        tagContainer.querySelector('span[data-variant-tag]').style.color = tagData.label_color;
      }
      else {
        tagContainer.querySelector('span[data-variant-tag]').style.color = '#828282';
      }

      if(tagData.background_color) {
        tagContainer.style.backgroundColor = tagData.background_color;
      }
      else {
        tagContainer.style.backgroundColor = '#E5E5E5';
      }
    } 
    else {
      tagContainer.style.display = 'none';
    }
  }

  _updateVariantRestockNotice(is_bundle = false, variantId, productId = null) {
    let variantMetafields = this.variantMetafields
    if (is_bundle) {
      variantMetafields = this._loadVariantMetafields(productId)
    }

    const variantMetafieldRow = variantMetafields.find(item => item.variant_id === variantId)
    let restockNotice = document.querySelector('.variant-restock-notice')
    if (productId) {
      restockNotice = document.querySelector(`.variant-restock-notice[data-product-id="${productId}"]`)
    }
    if (!restockNotice) return

    const messageEl = restockNotice.querySelector('.variant-restock-notice__message')
    if (!messageEl) return

    const middleEl = restockNotice.querySelector('[data-restock-middle]')

    if (variantMetafieldRow && variantMetafieldRow.back_in_stock_status) {
      if (middleEl) {
        middleEl.textContent = variantMetafieldRow.back_in_stock_middle || ''
      }
      restockNotice.style.display = 'flex'
    } else {
      if (middleEl) {
        middleEl.textContent = ''
      }
      restockNotice.style.display = 'none'
    }
  }

  _stickyATC() {
    const atcWrapper = this.querySelector('.product-form__buttons')
    if (!atcWrapper) return

    const offsetTop = atcWrapper.offsetTop + atcWrapper.offsetHeight + this.closest('.product-hero__grid').offsetTop
    if (offsetTop > window.scrollY) {
      // atcWrapper.classList.remove('product-form__buttons-hidden')
      // atcWrapper.classList.add('product-form__buttons-show')
      // this.submitButton.classList.add('rounded')
    } else {
      // atcWrapper.classList.remove('product-form__buttons-show')
      // atcWrapper.classList.add('product-form__buttons-hidden')
      // this.submitButton.classList.remove('rounded')
    }

  }

  getVariantCustomTag(variantId) {
    const tagEl = document.querySelector(`#VariantMetafields .variant-tag[data-variant-id="${variantId}"]`);
    return [{
      'label': tagEl?.dataset?.customTag || null,
      'textColor': tagEl?.dataset?.customColor || null,
      'bgColor': tagEl?.dataset?.customBgcolor || null,
      'icon': tagEl?.dataset?.customIcon || null,
    }];
  }
}

customElements.define('hh-product-form', HHProductForm)

document.addEventListener('DOMContentLoaded', function() {
  $('.js-product-panel .bundle-yotpo-holder').on('click', function() {
    $('html, body').animate({
        scrollTop: $('#reviewAnchor').offset().top
    }, 800); // 800 is the animation duration in milliseconds
  });

  $('.js-product-panel').on('click','.yotpo-widget-instance',function() {
    $('html, body').animate({
      scrollTop: $('#reviewAnchor').offset().top
    }, 800); // 800 is the animation duration in milliseconds
  });
});
